<template>
  <div>
    <section :id="$options.name" class="descriptions">
      <h2 class="descriptions__title">Informazioni su questa struttura</h2>
      <div class="descriptions__content">
        <template v-for="(desc, desc_index) in descriptions">
          <div v-if="desc_index < show" class="descriptions__item" :key="_uid + 'description' + desc_index">
            <span class="descriptions__item-label">
              <vb-icon
                class="descriptions__item-icon"
                :name="desc.icon"
                :size=16
              />
              {{ desc.name }}
            </span>
            <span class="descriptions__item-data" v-html="desc.data" />
          </div>
        </template>
      </div>
      <span v-if="descriptions.length > show" class="descriptions__show" v-b-modal="'descriptions__modal'">
        Mostra altro
        <vb-icon
          :name="'angle_small_right'"
          :size=18
          :color="sass('info')"
        />
      </span>
      <vb-modal
        :vb_options="{
          id: 'descriptions__modal',
          title: 'Informazioni su questa struttura',
          size: is_mobile() ? 'lg' : 'xl',
          centered: true,
          hide_footer: true
        }"
      >
        <div
          class="descriptions__modal-item"
          v-for="(desc, desc_index) in descriptions"
          :key="_uid + 'description' + desc_index"
        >
          <span class="descriptions__modal-label">
            <vb-icon
              class="descriptions__modal-icon"
              :name="desc.icon"
              :size=16
            />
            {{ desc.name }}
          </span>
          <span class="descriptions__modal-data" v-html="desc.data" />
        </div>
      </vb-modal>
    </section>
  </div>
</template>

<script>
import { build_data_items } from '@liveeps/utilities'

export default {
  inheritAttrs: false,
  name: 'descriptions',

  props: {
    property: Object,
  },

  components: {
  },

  data() {
    return {
      show: 5
    }
  },

  computed: {

    // Struttura dati: key, icon, name e content
    descriptions() {
      const map = [
        { key: 'short_description', icon: 'hotel', name: 'Descrizione' },
        { key: 'amenities', icon: 'menu', name: 'Servizi' },
        { key: 'dining', icon: 'cutlery', name: 'Ristorazione' },
        { key: 'national_ratings', icon: 'star', name: 'Classificazione ufficiale' },
        { key: 'business_amenities', icon: 'business_center', name: 'Servizi business' },
        { key: 'rooms', icon: 'door', name: 'Camere' },
        { key: 'attractions', icon: 'children_services', name: 'Attrazioni' },
        { key: 'location', icon: 'pin', name: 'Posizione' },
        { key: 'headline', icon: 'compass', name: 'Nelle vicinanze' },
        { key: 'renovations', icon: 'gallery', name: 'Ristrutturazioni'}
      ]
      return build_data_items(map, this.property.descriptions)
    }

  },

  created() {
  },

  mounted() {
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>

  .descriptions {
    @extend %section;
    @extend %section_margin;

    &__title {
      @extend %section__title;
    }

    &__content {
      @extend %section__content;
      line-height: normal;
    }

    &__item {
      border-bottom: 1px solid $gray-200;
      margin-bottom: $grid-gutter-width / 2;
      padding-bottom: $grid-gutter-width / 2;

      &:last-child {
        border-bottom: 0;
        padding-bottom: 0;
        margin-bottom: 0;
      }

      &-label {
        font-weight: $vb-font-weight-semibold;
        line-height: normal;
        display: flex;
        align-items: center;
        margin-bottom: $grid-gutter-width / 6;
      }

      &-icon {
        margin-right: $grid-gutter-width / 4;
      }

      &-data {
        line-height: $grid-gutter-width;
      }
    }

    &__modal {

      &-item {
        @extend .descriptions__item
      }

      &-label {
        @extend .descriptions__item-label;
      }

      &-icon {
        @extend .descriptions__item-icon;
      }

      &-data {
        @extend .descriptions__item-data;
      }
    }

    &__show {
      display: flex;
      color: var(--info);
      text-decoration: underline;
      cursor: pointer;
      align-items: flex-end;

      @include media-breakpoint-up(lg){
        margin-top: $grid-gutter-width / 2;
        margin-left: 20px;
      }
    }
  }

</style>